import { LanguageListItem } from "@/components/General/LanguageSelector/layouts/list/listItem.component";
import { Config } from "@/utils/config.utils";
import "./list.scss";

import { useIsClientSide } from "@/utils/hooks/isClient.hook";

type Props = {
    variant?: string;
};

const LanguageListSelector = ({ variant }: Props) => {
    const clientSide = useIsClientSide();

    if (!clientSide) return null;

    return (
        <div className="my-1">
            <ul className="language-selector__list">
                {Config.languages.map((language) => (
                    <li
                        className="language-selector__list-item"
                        key={language["language-code"]}
                    >
                        <LanguageListItem
                            language={language}
                            isCurrent={
                                language.locale === Config.general.locale
                            }
                            variant={variant}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default LanguageListSelector;
